<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Promo
        <small>Promo tools</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Promo</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h2><i class="fa fa-fw fa-bank"></i> BIN</h2>
                </div>
                <div class="panel-footer">Panel footer</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h2><i class="fa fa-fw fa-ticket"></i> Code</h2>
                </div>
                <div class="panel-footer">Panel footer</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <div class="panel panel-default">
                <div class="panel-body">
                  <h2><i class="fa fa-fw fa-cog"></i> Config</h2>
                </div>
                <div class="panel-footer">Panel footer</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PromoIndex',
};
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/Index.vue